import gql from 'graphql-tag';

export default gql`
  query GetAllStakeholders(
    $order: StakeholderOrderByInput
    $role: StakeholderRole
    $searchTerm: String
    $status: StakeholderStatus
  ) {
    stakeholders(
      orderBy: $order
      where: {
        role: $role
        role_not_in: [GUEST]
        status: $status
        OR: [
          { firstName_contains: $searchTerm }
          { lastName_contains: $searchTerm }
          { email_contains: $searchTerm }
          { cellNumber_contains: $searchTerm }
          { residentialAddress_contains: $searchTerm }
          { idNumber_contains: $searchTerm }
        ]
      }
    ) {
      createdAt
      id
      updatedAt
      firstName
      lastName
      dob
      country
      homeNumber
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      unitNumber
      status
      role
      properties {
        createdAt
        id
        code
        updatedAt
        address
        size
        valuation
        rooms
        erfNumber
        status
        salesAgent
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllStakeholders.ts